import { useEffect } from 'react';
import { useLocation } from 'react-router';

// Scroll to the widget referenced in the URL hash (e.g. #widget-core.bandwidth).
// Widgets are lazy-loaded, so we retry until the element appears in the DOM.
export const useScrollToHash = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;
    const elementId = location.hash.slice(1); // strip leading '#'
    let retries = 0;
    const maxRetries = 20; // ~5 s at 250 ms intervals
    let timeoutId: ReturnType<typeof setTimeout>;

    const tryScroll = () => {
      const el = document.getElementById(elementId);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      if (retries < maxRetries) {
        retries++;
        timeoutId = setTimeout(tryScroll, 250);
      }
    };
    tryScroll();

    return () => clearTimeout(timeoutId);
  }, [location.hash]);
};
